/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultiUserGroupVehicleGroupAssignmentCreate
 */
export interface MultiUserGroupVehicleGroupAssignmentCreate {
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiUserGroupVehicleGroupAssignmentCreate
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiUserGroupVehicleGroupAssignmentCreate
     */
    vehicleGroupIds: Array<string>;
}

/**
 * Check if a given object implements the MultiUserGroupVehicleGroupAssignmentCreate interface.
 */
export function instanceOfMultiUserGroupVehicleGroupAssignmentCreate(value: object): value is MultiUserGroupVehicleGroupAssignmentCreate {
    if (!('userGroupIds' in value) || value['userGroupIds'] === undefined) return false;
    if (!('vehicleGroupIds' in value) || value['vehicleGroupIds'] === undefined) return false;
    return true;
}

export function MultiUserGroupVehicleGroupAssignmentCreateFromJSON(json: any): MultiUserGroupVehicleGroupAssignmentCreate {
    return MultiUserGroupVehicleGroupAssignmentCreateFromJSONTyped(json, false);
}

export function MultiUserGroupVehicleGroupAssignmentCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiUserGroupVehicleGroupAssignmentCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'userGroupIds': json['userGroupIds'],
        'vehicleGroupIds': json['vehicleGroupIds'],
    };
}

export function MultiUserGroupVehicleGroupAssignmentCreateToJSON(json: any): MultiUserGroupVehicleGroupAssignmentCreate {
    return MultiUserGroupVehicleGroupAssignmentCreateToJSONTyped(json, false);
}

export function MultiUserGroupVehicleGroupAssignmentCreateToJSONTyped(value?: MultiUserGroupVehicleGroupAssignmentCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userGroupIds': value['userGroupIds'],
        'vehicleGroupIds': value['vehicleGroupIds'],
    };
}

